var map = {
	"./Atom_logo_colored.png": 7199,
	"./Bower_logo_colored.png": 7889,
	"./CPAN_logo_colored.png": 4495,
	"./CRAN_logo_colored.png": 6699,
	"./Cargo_logo_colored.png": 6387,
	"./Clojars_logo_colored.png": 6465,
	"./CocoaPods_logo_colored.png": 794,
	"./Go_logo_colored.png": 963,
	"./HTML_logo_colored.png": 4449,
	"./Hackage_logo_colored.png": 4441,
	"./Hex_logo_colored.png": 9704,
	"./Javascript_logo_colored.png": 3446,
	"./Maven_logo_colored.png": 5968,
	"./Meteor_logo_colored.png": 304,
	"./NPM_logo_colored.png": 8053,
	"./NuGet_logo_colored.png": 1663,
	"./Packagist_logo_colored.png": 5962,
	"./PlatformIO_logo_colored.png": 5995,
	"./Pub_logo_colored.png": 7843,
	"./Puppet_logo_colored.png": 8347,
	"./Pypi_logo_colored.png": 8521,
	"./RubyGems_logo_colored.png": 951
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1808;